<template>
  <v-dialog :value="true" width="750">
    <v-card>
      <v-card-title class="primary text-h6 white--text">
        Tem certeza que deseja ordenar as inscrições?
      </v-card-title>

      <v-card-text class="py-3">
        <v-row>
          <v-col cols="12">
            Esta ação não podera ser desfeita!
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions class="d-flex justify-end">
        <CPTBtn label="Não" @click="$emit('close')" />
        <CPTBtn label="Sim" @click="$emit('ordenar')" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CPTBtn from "@/components/Btn";

export default {
  name: "dialog-ordenar-inscricoes",

  components: {
    CPTBtn
  }
};
</script>
